module.exports = __webpack_public_path__ + "img/pic18.21467b24.png";